const userDataFormHR = {
    "view": {
        "title": "Dovršite svoje podatke",
        "stepZero": {
            "title": "Izjava",
            "form": {
                "label": {
                    "declarationPoint1": "Davanjem ovih informacija, priznajete i slažete se da će one biti pružene prema vašem najboljem znanju i sposobnostima. Nastojimo osigurati da su sve informacije točne i istinite.",
                    "declarationPoint2": "Molimo vas da budete svjesni da davanje lažnih informacija ili pogrešno predstavljanje istine može imati značajne posljedice. Potičemo sve korisnike da provjere informacije koje pružaju i da koriste ovu platformu odgovorno.",
                    "declarationPoint3": "Odgovornost za bilo kakve netočne informacije ili pogreške leži isključivo na osobi koja pruža informacije. Ne preuzimamo odgovornost za posljedice netočnih ili obmanjujućih informacija koje pružaju korisnici.",
                    "declarationPoint4": "Klikom na <strong>'Dalje'</strong>, pristajete na ove uvjete i potvrđujete da ste potpuno svjesni implikacija davanja netočnih ili lažnih informacija.",
                    "declarationAgreement": "Potpuno se slažem i razumijem gore navedene uvjete."
                },
                "button": {
                    "next": "Dalje"
                }
            }
        },
        "stepOne": {
            "title": "Osobni podaci",
            "form": {
                "label": {
                    "firstName": "Ime",
                    "lastName": "Prezime",
                    "streetAndNumber": "Ulica i broj",
                    "zipCode": "Poštanski broj",
                    "city": "Grad",
                    "country": "Država"
                },
                "placeholder": {
                    "country": "Odaberite državu"
                },
                "help_text": {
                    "firstName": "Ako se registrirate kao društvo s ograničenom odgovornošću ili drugi poslovni subjekt, ovo polje će se koristiti za ime izvršnog direktora.",
                    "lastName": "Ako se registrirate kao društvo s ograničenom odgovornošću ili drugi poslovni subjekt, ovo polje će se koristiti za prezime izvršnog direktora.",
                    "country": "Ako se registrirate kao društvo s ograničenom odgovornošću ili drugi poslovni subjekt, ovo polje će se koristiti za državu izvršnog direktora."
                },
                "button": {
                    "next": "Dalje"
                }
            }
        },
        "stepTwo": {
            "title": "Poslovni podaci",
            "form": {
                "label": {
                    "businessType": "Vrsta poslovanja",
                    "companyName": "Naziv tvrtke",
                    "businessStreet": "Ulica i broj",
                    "businessCity": "Grad",
                    "businessZip": "Poštanski broj",
                    "businessCountry": "Država",
                    "ceoFirstName": "Pravno odgovorna osoba / Ime izvršnog direktora",
                    "ceoLastName": "Pravno odgovorna osoba / Prezime izvršnog direktora",
                    "tradeRegistryExport": "Izvoz iz trgovačkog registra",
                    "tradeRegistryCompanyUrl": "URL tvrtke u trgovačkom registru",
                    "vatNumber": "PDV broj",
                    "taxNumber": "Porezni broj"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Samostalno poduzetništvo",
                        "limitedLiabilityCompany": "Društvo s ograničenom odgovornošću",
                        "partnershipOrganized": "Organizirano partnerstvo",
                        "publicLimitedCompanyByShares": "Dioničko društvo",
                        "other": "Ostalo"
                    }
                },
                "placeholder": {
                    "businessType": "Odaberite vrstu poslovanja",
                    "businessCountry": "Odaberite državu"
                },
                "help_text": {
                    "companyName": "Naziv tvrtke treba biti u skladu s onim što je prvotno predano u Stripe. Mijenjajte samo ako se razlikuje od prvotno predanog.",
                    "tradeRegistryExport": "Molimo vas da dostavite službeni izvoz iz trgovačkog registra vaše tvrtke. Samo PDF, maksimalna veličina datoteke 5 MB. Ako trebate pomoć u pronalaženju izvoza iz trgovačkog registra, molimo kontaktirajte registar u vašoj zemlji. Neslužbeni popis registara možete pronaći <1>ovdje</1>.",
                    "tradeRegistryCompanyUrl": "Molimo vas da navedete URL vaše tvrtke u trgovačkom registru vaše zemlje. Ako vaš registar to ne podržava, molimo umetnite samo URL registra."
                },
                "button": {
                    "previous": "Prethodno",
                    "next": "Dalje"
                }
            }
        },
        "stepThree": {
            "title": "Potvrda",
            "form": {
                "label": {
                    "personalInformation": "Osobni podaci",
                    "personalName": "Ime",
                    "personalAddress": "Adresa",
                    "businessInformation": "Poslovni podaci",
                    "companyName": "Tvrtka",
                    "ceoName": "Ime izvršnog direktora",
                    "businessAddress": "Adresa",
                    "businessType": "Vrsta poslovanja",
                    "taxNumber": "Porezni broj",
                    "vatNumber": "PDV broj",
                    "tradeRegistryExportUploaded": "Izvoz iz trgovačkog registra učitan",
                    "tradeRegistryCompanyUrl": "URL tvrtke u trgovačkom registru",
                    "notAvailable": "N/A"
                },
                "button": {
                    "previous": "Prethodno",
                    "save": "Spremi",
                    "next": "Dalje"
                }
            },
            "message": {
                "success": "Vaše informacije su ažurirane!",
                "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Predajte svoje informacije",
                    "body": {
                        "point1": "Klikom na <strong>'Potvrdi'</strong>, potvrđujete da su sve informacije koje ste pružili točne i istinite prema vašem najboljem znanju.",
                        "point2": "Potvrđujete li da su svi navedeni podaci točni i priznajete potencijalne posljedice davanja netočnih informacija?"
                    },
                    "button": {
                        "confirm": "Potvrdi",
                        "cancel": "Otkaži"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Potvrdite broj mobitela",
            "form": {
                "label": {
                    "mobileNumber": "Unesite svoj broj mobitela",
                    "deliveryMedium": "Način dostave: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Napomena: Broj mobitela je potreban za verifikaciju kao standardna procedura jer se može koristiti za validaciju prijave. Morate posjedovati broj i imati pristup njemu za nesmetan proces verifikacije.",
                    "isFormUSorCanada": "* Ako ste iz SAD-a ili Kanade, molimo kontaktirajte našu podršku nakon unosa broja mobitela.",
                    "deliveryMediumWhatsapp": "Napomena: Molimo osigurajte da imate WhatsApp račun na ovom broju kako biste mogli primiti poruku.",
                    "otp": "Molimo unesite OTP poslan na vaš broj mobitela."
                },
                "message": {
                    "errorMobileNumberEmpty": "Broj mobitela je obavezan.",
                    "errorMobileNumberInvalid": "Nevažeći broj mobitela.",
                    "errorMobileNumberSame": "Ovaj broj je već dodan i verificiran s vašim računom.",
                    "errorOTPRequired": "OTP je obavezan.",
                    "errorOtpSendLimitExhasuted": "Ne možete više tražiti OTP jer ste iscrpili <strong>MAX limit ({{maxLimit}})</strong> za zahtjeve za OTP. Molimo kontaktirajte podršku za daljnje informacije!",
                    "errorMobileUpdateLimitExhausted": "Ne možete ažurirati svoj broj mobitela jer ste ga već ažurirali MAX ({{maxLimit}}) puta. Molimo kontaktirajte podršku za daljnje informacije!"
                },
                "button": {
                    "sendOTP": "Pošalji OTP",
                    "next": "Dalje",
                    "confirm": "Potvrdi",
                    "notGettingCode": "Ne primam kod"
                }
            },
            "message": {
                "success": "Broj mobitela verificiran!",
                "errorValidatingOTP": "Greška u validaciji OTP-a!",
                "errorSendingOTP": "Došlo je do problema pri slanju OTP koda, molimo pokušajte ponovno kasnije!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Ne primam kod",
                    "body": {
                        "point1": "Čini se da trenutno postoji problem s slanjem verifikacijskog koda. Molimo pokušajte ponovno kasnije",
                        "point2": "Za pomoć, molimo kontaktirajte našu podršku putem Centra za pomoć."
                    },
                    "button": {
                        "close": "Zatvori"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Možete ponovno zatražiti OTP za <strong>{{secondsRemaining}}</strong> sekundi"
                }
            }
        },
        "stepFive": {
            "title": "Verifikacija identiteta",
            "form": {
                "label": {
                    "identityVerificationDescription": "Molimo kliknite na donju poveznicu za početak verifikacije identiteta.",
                    "identityVerificationResults": "Rezultati verifikacije identiteta"
                },
                "button": {
                    "loading": "Učitavanje...",
                    "verifyIdentity": "Verificiraj identitet"
                },
                "table": {
                    "column": {
                        "type": "Vrsta",
                        "status": "Status",
                        "details": "Detalji"
                    },
                    "label": {
                        "selfieVerification": "Verifikacija selfija",
                        "documentVerification": "Verifikacija dokumenta",
                        "verified": "Verificirano",
                        "notVerified": "Nije verificirano",
                        "notAvailable": "N/A"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Vaši identifikacijski podaci su verificirani, naš tim će pregledati identifikacijske podatke i dati konačno odobrenje u roku od 2-3 radna dana.",
                    "identityVerificationFailed": "Vaši identifikacijski podaci nisu mogli biti verificirani, molimo ponovno pošaljite informacije! Imate još samo <strong>{{attemptsRemaining}}</strong> pokušaj za verifikaciju identiteta.",
                    "identityVerificationMaxAttempts": "Iscrpili ste maksimalni broj pokušaja za verifikaciju identiteta, molimo kontaktirajte podršku za daljnje informacije."
                }
            }
        },
        "stepSix": {
            "title": "Potpišite ugovor",
            "form": {
                "label": {
                    "signContract": "Potpišite ugovor"
                }
            }
        },
        "stepSeven": {
            "title": "Odobrenje",
            "form": {
                "message": {
                    "approval": "Naš tim će pregledati sve informacije koje ste pružili i dati konačno odobrenje u roku od 3 radna dana."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Uspješno potpisivanje ugovora :)",
            "description": "Uspješno ste potpisali svoj ugovor, status će uskoro biti ažuriran na vašem računu, molimo osvježite stranicu za nekoliko sekundi."
        },
        "signLater": {
            "title": "Potpisivanje ugovora kasnije ...",
            "description": "Odabrali ste potpisati ugovor kasnije, molimo dovršite ovaj korak što je prije moguće kako biste omogućili distribuciju."
        },
        "signDeclined": {
            "title": "Odbijeno potpisivanje ugovora :(",
            "description": "Odbili ste potpisati ugovor, to će odgoditi proces omogućavanja distribucije."
        },
        "signCompleted": {
            "title": "Potpisivanje ugovora završeno :)",
            "description": "Vaš ugovor je finaliziran, status će uskoro biti ažuriran na vašem računu, molimo osvježite stranicu za nekoliko sekundi."
        }
    }
};

export default userDataFormHR;